import 'css-chunk:src/app/utils/getColumnSearchProps/getColumnSearchProps.scss';export default {
  "SearchDropdown": "_SearchDropdown_1nlf8_1",
  "searchInput": "_searchInput_1nlf8_4",
  "searchSubmitButton": "_searchSubmitButton_1nlf8_9",
  "searchResetButton": "_searchResetButton_1nlf8_13",
  "selectedFilterIcon": "_selectedFilterIcon_1nlf8_16",
  "unselectedFilterIcon": "_unselectedFilterIcon_1nlf8_19"
};